export default "__VITE_ASSET__UKbRFUtq__"